/* TKMAUTO popup handler — runs on every page, hooks popup whenever EasyDialog mounts it.
   - Submits email via AJAX → swaps to success view + shows NEWMEMBER100 code
   - v9 cookie policy (per business decision 2026-06-04):
       • Dismissed (X / "Don't show again"): 1 HOUR (was 14 days)
       • Submitted email: NO cookie — popup shows again on next page load
       • Legacy long cookies (incl. previous 14/90/99999-day): capped to 1 HOUR
   - Supports ?clear_popup=1 query param to force-clear cookie for testing
*/
(function () {
  'use strict';

  var COOKIE_NAME  = 'bls-newsletter-popup';
  var DAYS_DISMISS = 1 / 24;   // 1 hour (was 14 days)
  var DAYS_SUBMIT  = 0;        // 0 = no cookie set on submit — popup reappears next page load
  var DAYS_MAX_CAP = 1 / 24;   // Cap any pre-existing cookie down to 1 hour

  /* ──────────────── COOKIE UTILS ──────────────── */
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(^|; )' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]+)'));
    return m ? m[2] : '';
  }
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function deleteCookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
  }

  /* ──────────────── COOKIE NORMALIZATION ──────────────── */
  // Cap any pre-existing 99999-day cookie down to our max — runs once per session.
  function normalizeCookieLife() {
    var existing = getCookie(COOKIE_NAME);
    if (!existing) return;
    var marker = getCookie('tkmpp-capped');
    if (marker) return; // already capped this session
    // Re-set with shorter expiry. Value preserved; only expiry shrinks.
    setCookie(COOKIE_NAME, existing, DAYS_MAX_CAP);
    setCookie('tkmpp-capped', '1', 1); // mark, refresh daily
  }

  /* ──────────────── ?clear_popup=1 OVERRIDE ──────────────── */
  function handleClearParam() {
    if (location.search.indexOf('clear_popup') < 0) return;
    deleteCookie(COOKIE_NAME);
    deleteCookie('tkmpp-capped');
    try { console.log('[TKMAUTO] popup cookie cleared via ?clear_popup'); } catch (e) {}
  }

  /* ──────────────── HOOK FORM SUBMIT ──────────────── */
  function bindForm(scope) {
    var form = scope.querySelector('.tkmpp-form');
    var formView = scope.querySelector('.tkmpp-form-view');
    var successView = scope.querySelector('.tkmpp-success-view');
    if (!form || form.dataset.tkmppBound) return;
    form.dataset.tkmppBound = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var emailInput = form.querySelector('input[type=email]');
      var emailVal = emailInput ? emailInput.value.trim() : '';
      if (!emailVal || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)) {
        if (emailInput) {
          emailInput.style.borderColor = '#ff8b7d';
          emailInput.focus();
        }
        return false;
      }

      var btn = form.querySelector('button[type=submit]');
      var origLabel = btn ? btn.innerHTML : '';
      if (btn) {
        btn.disabled = true;
        btn.style.opacity = '0.75';
        btn.innerHTML = 'Sending...';
      }

      var fd = new FormData(form);
      if (!fd.get('form_type')) fd.append('form_type', 'customer');
      if (!fd.get('utf8')) fd.append('utf8', '✓');

      fetch('/contact', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        redirect: 'follow'
      }).then(function () {
        if (formView) formView.style.display = 'none';
        if (successView) {
          successView.style.display = 'block';
          successView.style.opacity = '0';
          successView.style.transition = 'opacity .35s ease';
          requestAnimationFrame(function(){ successView.style.opacity = '1'; });
        }
        // Submitted → DAYS_SUBMIT (currently 0 = no cookie, popup reappears next visit per business decision)
        if (DAYS_SUBMIT > 0) {
          setCookie(COOKIE_NAME, '1', DAYS_SUBMIT);
        } else {
          deleteCookie(COOKIE_NAME);
          deleteCookie('tkmpp-capped');
        }
        try { if (window.dataLayer) window.dataLayer.push({ event: 'newsletter_signup', value: 'NEWMEMBER100' }); } catch (e) {}
      }).catch(function () {
        if (btn) {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.innerHTML = origLabel || 'Get My $100 Code';
        }
        if (emailInput) emailInput.style.borderColor = '#ff8b7d';
      });

      return false;
    }, true);
  }

  /* ──────────────── HOOK COPY BUTTON ──────────────── */
  function bindCopy(scope) {
    var copyBtn = scope.querySelector('.tkmpp-copy');
    if (!copyBtn || copyBtn.dataset.tkmppBound) return;
    copyBtn.dataset.tkmppBound = '1';
    copyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var code = copyBtn.dataset.code || 'NEWMEMBER100';
      var done = function () {
        var orig = copyBtn.innerHTML;
        copyBtn.innerHTML = 'Copied';
        copyBtn.style.background = '#fff';
        setTimeout(function () {
          copyBtn.innerHTML = orig;
          copyBtn.style.background = '#C9A979';
        }, 1800);
      };
      function fallback() {
        var t = document.createElement('textarea');
        t.value = code;
        t.style.position = 'fixed';
        t.style.opacity = '0';
        document.body.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(t);
        done();
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, fallback);
      } else {
        fallback();
      }
    });
  }

  /* ──────────────── HOOK "DON'T SHOW AGAIN" CHECKBOX ──────────────── */
  // Override theme.js handler which sets 99999-day cookie. Capture-phase beats theme.js.
  function bindDoNotShow(scope) {
    var cb = scope.querySelector('#doNotShow');
    if (!cb || cb.dataset.tkmppBound) return;
    cb.dataset.tkmppBound = '1';
    cb.addEventListener('change', function (e) {
      // Stop theme.js handler from running with 99999 days
      e.stopImmediatePropagation();
      if (cb.checked) {
        setCookie(COOKIE_NAME, '1', DAYS_DISMISS); // 1 hour (v9)
      } else {
        deleteCookie(COOKIE_NAME);
      }
    }, true);
  }

  /* ──────────────── HOOK DIALOG CLOSE BUTTON ──────────────── */
  // v10 FIX: EasyDialog's real close button classes are dlg-close-x / icon-x —
  // previous matcher (dlg-close / icon-close exact match) NEVER fired, so the
  // cookie was never set on X-close and the popup re-appeared on every page.
  function isCloseElement(t) {
    if (!t || !t.classList) return false;
    // Match any dlg-family close class variant
    if (t.classList.contains('dlg-close') || t.classList.contains('dlg-close-x') ||
        t.classList.contains('icon-close') || t.classList.contains('icon-x')) return true;
    // Any class containing "close" inside a dialog wrapper
    var cls = (typeof t.className === 'string') ? t.className : '';
    if (cls.indexOf('close') >= 0 && t.closest && t.closest('.dlg')) return true;
    // Buttons/links with close-ish aria-label or title
    var label = ((t.getAttribute && (t.getAttribute('aria-label') || t.getAttribute('title'))) || '').toLowerCase();
    if (label.indexOf('close') >= 0) return true;
    return false;
  }
  function bindCloseBtn() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== document.body) {
        if (isCloseElement(t)) {
          if (document.querySelector('.tkmpp-root')) {
            if (!getCookie(COOKIE_NAME)) {
              setCookie(COOKIE_NAME, '1', DAYS_DISMISS);
            }
          }
          break;
        }
        t = t.parentNode;
      }
    }, true);
  }

  /* ──────────────── SCAN + OBSERVE ──────────────── */
  // v10 FAILSAFE: the moment the popup is SHOWN, set the 1-hour cookie.
  // This guarantees it cannot re-pop on every page navigation even if the
  // close button handler fails for any reason (class mismatch, tap missed,
  // JS error). Frequency is capped at once per hour per the business rule.
  function markShown() {
    if (!getCookie(COOKIE_NAME)) {
      setCookie(COOKIE_NAME, '1', DAYS_DISMISS);
    }
  }
  function scan() {
    var roots = document.querySelectorAll('.tkmpp-root');
    for (var i = 0; i < roots.length; i++) {
      // Only count as "shown" when it's inside an open dialog (not the hidden source div)
      var host = roots[i].closest ? roots[i].closest('.dlg') : null;
      if (host && !roots[i].dataset.tkmppShown) {
        roots[i].dataset.tkmppShown = '1';
        markShown();
      }
      bindForm(roots[i]);
      bindCopy(roots[i]);
      bindDoNotShow(roots[i]);
    }
  }

  function init() {
    handleClearParam();
    normalizeCookieLife();
    scan();
    bindCloseBtn();
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) { scan(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 90000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
